<template>
  <AppLayout>
    <div class="max-w-xl mx-auto">
      <div class="move-card p-6 md:p-8 text-left">
        <div class="mb-6">
          <div
            class="inline-flex items-center justify-center w-12 h-12 rounded-2xl mb-4"
            style="background: var(--move-accent-soft); color: var(--move-accent)"
          >
            <span class="material-icons">view_kanban</span>
          </div>
          <p class="move-page-intro">
            Give your board a clear name — e.g. “Q3 Launch”, “Support Ops”, or “Content Calendar”.
          </p>
        </div>

        <div v-if="loading" class="flex justify-center py-10">
          <div class="move-spinner" aria-label="Creating board" />
        </div>

        <div v-if="error" class="move-alert-error mb-5" role="alert">
          {{ error }}
        </div>

        <form v-if="!loading" class="space-y-5" @submit.prevent="createBoard">
          <div class="move-field">
            <label for="name">Board name</label>
            <input
              id="name"
              v-model="name"
              type="text"
              required
              class="move-input"
              placeholder="e.g. Product launch"
              autocomplete="off"
            />
          </div>

          <div class="flex flex-col sm:flex-row gap-3 pt-2">
            <button type="submit" class="move-btn-primary flex-1 w-full sm:w-auto">
              <span class="material-icons text-lg">add</span>
              Create board
            </button>
            <router-link to="/boards" class="move-btn-ghost flex-1 sm:flex-none justify-center">
              Cancel
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { moveApi } from '../services/moveApi'
import AppLayout from '../layouts/AppLayout.vue'

const router = useRouter()
const name = ref('')
const loading = ref(false)
const error = ref('')

const createBoard = async () => {
  try {
    loading.value = true
    error.value = ''

    if (!name.value.trim()) {
      error.value = 'Please enter a board name'
      return
    }

    const { data } = await moveApi.createBoard(name.value.trim())
    router.push(`/board/${data.data.id}`)
  } catch (err) {
    console.error('Error creating board:', err)
    error.value = err.response?.data?.message || err.message || 'Failed to create board'
  } finally {
    loading.value = false
  }
}
</script>

<script>
export default {
  name: 'CreateBoardView'
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');

.material-icons {
  font-family: 'Material Icons', sans-serif;
  font-weight: normal;
  font-style: normal;
  line-height: 1;
  display: inline-block;
}
</style>
